import React from 'react';
import styles from './SidebarToggleButton.module.css';
import ChevronLeft from '../../assets/icons/chevron-left.svg';
import ChevronRight from '../../assets/icons/chevron-right.svg';

const SidebarToggleButton = ({ collapsed, onClick }) => {
  return (
    <button
      className={styles.toggleButton}
      onClick={onClick}
      aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      type="button"
    >
      {collapsed ? (
        <img src={ChevronRight} alt="expand" width={24} height={24} />
      ) : (
        <img src={ChevronLeft} alt="collapse" width={24} height={24} />
      )}
    </button>
  );
};

export default SidebarToggleButton;
